export default __webpack_public_path__ + "c79e68b7efaec11980b82c1ee617270e.jpg";